import {useRef, useState} from "react";
import { t } from "i18next";
import { Select } from 'antd';
import ApiService from "../../core/service/ApiService";
import DebounceSelect from "../../core/components/DebounceSelect";
import "./patient-select.css";

export default function PatientSelect({ onSelect }) {
    const [search, setSearch] = useState('')
    const [loadingLast, setLoadingLast] = useState(false)
    const [lastAppointments, setLastAppointments] = useState([]);
    const searchResult = useRef([])

    const load = async () => {
        setLoadingLast(true)
        const res = await ApiService.Appointment.GetLastAppointmentPatients();
        setLoadingLast(false)
        if (res.success) {
            setLastAppointments(res.data)
        }
    }

    // Son randevular listesi kutu açılınca çekilir (ekran açılışında değil); her açılışta güncel gelir.

    const searchPatient = async (value) => {
        if (!value)
            return []

        const res = await ApiService.Patient.SearchPatient(value);

        if (res.success) {
            searchResult.current = res.data
            return res.data.map(x => {
                return {
                    label: (
                        <div>
                            <b>{x.name} {x.lastname}</b>
                            {` - `}ID: {x.customId}
                        </div>
                    ),
                    value: x.id
                }
            })
        }
        return []
    }

    return (
        <div style={{ display: 'flex', alignItems: 'center', margin: 0, padding: 0, flex: 1 }}>
            <DebounceSelect
                placeholder={t('Search Patient')}
                style={{ width: '100%' }}
                debounceTimeout={250}
                loading={loadingLast}
                labelInValue={true}
                mode={'single'}
                showSearch={true}
                onSelect={(e) => {
                    const pat = [...lastAppointments, ...searchResult.current].find(x => x.id === e.value)
                    onSelect && onSelect(e.value, pat) && setSearch('')
                }}
                value={search ? search : undefined}
                onChange={(e) => setSearch(e)}
                fetchOptions={async (val) => searchPatient(val)}
                onDropdownVisibleChange={(open) => open && load()}
                popupClassName={'patient-select-popup'}
                // Kutu dar kalırsa bile liste ad + kimlik sığacak kadar geniş açılır.
                popupMatchSelectWidth={320}
            >
                <Select.OptGroup value={'X'} label={t('Last Appointments')}>
                    {
                        lastAppointments.map(x => (
                            <Select.Option key={x.id} value={x.id}>
                                <div>
                                    <b>{x.name} {x.lastname}</b>
                                    {x.customId && ` - ID: ${x.customId}`}
                                </div>
                            </Select.Option>
                        ))
                    }
                </Select.OptGroup>
            </DebounceSelect>
        </div>
    )
}